import service from "@/utils/server";

// 上传图片
export function uploadImg(data) {
  console.log("uploadImg:", data);
  return service.request({
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: `https://ex.weasley.tv/mpserver/midgateway.php`,
    data: data,
  });
}
// 预约展馆
export function register(data) {
  console.log("registerRoom:", data);
  data.a = "registerRoom";
  data.plat = window.plat;
  return service.request({
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: `https://ex.weasley.tv/mpserver/midgateway.php`,
    data: data,
  });
}

// 预约房间图
export function registerRoom(data) {
  data.a = "registerRoomUrl";
  data.plat = window.plat;
  return service.request({
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: `https://ex.weasley.tv/mpserver/midgateway.php`,
    data: data,
  });
}

export function registerWX(data) {
  return service.request({
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: `https://ex.weasley.tv/mpserver/wxgateway.php`,
    data: data,
  });
}
// 查询单据详情
export function receiptDetail(id) {
  return service.request({
    url: `receiptDetail`,
    method: "get",
    headers: {
      Accept: "application/json;charset=UTF-8",
    },
    params: { id: id },
  });
}

export function receiptRewardDetail(id){
  return service.request({
    url: `expenseDetail`,
    method: "get",
    headers: {
      Accept: "application/json;charset=UTF-8",
    },
    params: { id: id },
  });
}
// 登录根据openid
export function userLoginByOpenId(code) {
  return service.request({
    url: `userLoginByOpenId`,
    method: "get",
    headers: {
      Accept: "application/json;charset=UTF-8",
    },
    params: { code: code },
  });
}

export function FReceiptReceiver (parameter) {
  return service.request({
      url: 'receiptReceiver',
      method: 'get',
      headers: {
        'Accept': 'application/json;charset=UTF-8'
      },
      params: parameter
    })
}
// 审核驳回
export function FReceiptRefuse (parameter) {
  return service.request({
      url: 'receiptRefuse',
      method: 'get',
      headers: {
        'Accept': 'application/json;charset=UTF-8'
      },
      params: parameter
    })
}
// 审核通过
export function FReceiptPass (parameter) {
  return service.request({
      url: 'receiptPass',
      method: 'get',
      headers: {
        'Accept': 'application/json;charset=UTF-8'
      },
      params: parameter
    })
}

// 审核强制通过
export function FReceiptPassForce (parameter) {
  return service.request({
      url: 'receiptPassForce',
      method: 'get',
      headers: {
        'Accept': 'application/json;charset=UTF-8'
      },
      params: parameter
    })
}

// 出纳记录
export function FCashierRecInfo (parameter) {
  return service.request({
      url: 'cashierRecInfo',
      method: 'get',
      headers: {
        'Accept': 'application/json;charset=UTF-8'
      },
      params: parameter
    })
}